import { useQuery } from '@tanstack/react-query';
import { useS3Uploader } from '../useS3Uploader';
import { fetchOrganisationViewMore } from './helper';

export const useOrganisationViewMore = (role: string, organisationId: string) => {
  const { generateSignedUrl } = useS3Uploader();
  const userAccessToken =
    localStorage.getItem('user_access_token') !== 'null'
      ? localStorage.getItem('user_access_token') || ''
      : '';

  return useQuery({
    queryKey: ['organisation-view-more', organisationId, role],
    queryFn: () =>
      fetchOrganisationViewMore({
        organisationId,
        role,
        userAccessToken,
        generateSignedUrl
      }),
    enabled: Boolean(organisationId && role && userAccessToken),
    staleTime: 5 * 60 * 1000
  });
};
